import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";
// DESIGN-2A: self-hosted variable fonts (no runtime CDN). Each ships woff2 with font-display: swap.
// Heebo carries the Hebrew glyphs the Latin Sora/Source-Sans lack (see the Tailwind font stacks).
import "@fontsource-variable/sora";
import "@fontsource-variable/source-sans-3";
import "@fontsource-variable/heebo";
import "./index.css";
import { i18nReady } from "./i18n";
import App from "./App";
import { exposeBuildInfo } from "@/lib/buildInfo";
import { redirectWrongOriginAppRoute } from "@/lib/domainHardening";
import { runtimeConfig } from "@/lib/runtimeConfig";

const queryClient = new QueryClient();

const backendUrl = runtimeConfig.backendUrl;
exposeBuildInfo();
redirectWrongOriginAppRoute();

if (!backendUrl) {
  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.error("REACT_APP_BACKEND_URL is not set in .env");
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));

// W14: the first render waits for the ACTIVE language's dictionary (its chunk was requested when
// i18n.js evaluated, so it downloads while the rest of main.js is still being parsed) -- rendering
// earlier would paint raw keys for a frame.
i18nReady.then(() => root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* Opt into the React Router v7 transitions early — silences the runtime future-flag
          warnings and matches what the test suite already passes to MemoryRouter. */}
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <App />
        <Toaster
          richColors
          position="top-right"
          toastOptions={{
            className: "font-body",
            style: { borderRadius: 12 },
          }}
        />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
));

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch(() => {
      if (process.env.NODE_ENV !== "production") {
        // eslint-disable-next-line no-console
        console.warn("Service worker registration failed");
      }
    });
  });
}

